import {Injectable} from '@angular/core';
import {UtilsService} from './utils.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import gql from 'graphql-tag';
import {Apollo} from 'apollo-angular';

@Injectable()
export class DistrictsService {

  constructor(
    private httpClient: HttpClient,
    private utils: UtilsService,
    private apollo: Apollo
  ) {
  }

  list(query?): Observable<any> {

    let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.utils.apiEndpoint + 'districts', query, {
      responseType: 'json',
      headers: httpHeaders
    });
  }

  getAllDistricts() {
    return this.apollo
      .watchQuery({
        query: gql`
          {
            districts {
              id
              name
              slug
            }
          }
        `,
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      })
      .valueChanges;
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/districts.service.ts